import React from "react";
import { connect } from "react-redux";
import { bindActionCreators } from "redux";
import Header from "./component";
import { GetUserById } from "../../pages/settings/actions";
import { getAssessmentAttemptByUserId } from "../../pages/dashboard/actions";

const mapStateToProps = ({ funnelStep }) => ({
  funnelStep,
});

const mapDispatchToProps = (dispatch) =>
  bindActionCreators(
    {
      GetUserByIdConnect: GetUserById,
      getAssessmentAttemptByUserIdConnect: getAssessmentAttemptByUserId,
    },
    dispatch
  );

export default connect(mapStateToProps, mapDispatchToProps)(Header);
